import { Box, type BoxProps } from '@pets-ui/Box/Box'
import { colors } from '@pets-ui/tokens/colors.stylex'

export const CategoryHighlight = (props: BoxProps) => {
  return (
    <Box position="absolute" right={0} top={0} borderRadius="50%" width={5} height={5} backgroundColor={colors.red600} {...props} />
  )
}
